<div class="component-container">
  <app-review-section
    #oldMeterDataSection
    [title]="
      showData ? ('facilities-data.old-meter-data-title' | translate) : ('basic-profile.jurisdiction.meter-data.meter_data' | translate)
    "
    [tooltip]="'tooltips.facilities-data.old-meter-data' | translate"
    [showTooltip]="infoBubblesData?.showOldMeterDataHeaderInfo"
    [sectionId]="oldMeterDataSectionIdentifier"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView">
    <form class="form-background form-font-size" [formGroup]="meterFG">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label for="old-meter-number" class="ui-g-5 field-label text-right-align" [ngClass]="{ required: isMeterNumberRequired }">
            <ng-container *ngIf="showData">{{ 'facilities-data.form-fields.meter-number' | translate }}</ng-container>
            <ng-container *ngIf="!showData">{{ 'facilities-data.form-fields.meter-number-old-meter' | translate }}</ng-container>
          </label>
          <input
            id="old-meter-number"
            pInputText
            formControlName="meterNumber"
            type="text"
            [readOnly]="!oldMeterDataSection.isDataEditable"
            [required]="isMeterNumberRequired" />
        </div>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows" *ngIf="meterFG.get('meterReading')">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
          <label for="old-meter-reading" class="ui-g-5 field-label text-right-align">
            {{ 'facilities-data.form-fields.meter-reading' | translate }}
          </label>
          <input
            id="old-meter-reading"
            pInputText
            formControlName="meterReading"
            [appNumber]="true"
            [readOnly]="!oldMeterDataSection.isDataEditable" />
        </div>
      </div>

      <div
        class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows"
        *ngIf="meterFG.get('meterDocumentName') && oldMeterDataSection.isDataEditable">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 field-rows">
          <label for="old-meter-image" class="ui-g-5 field-label text-right-align">
            {{ 'facilities-data.form-fields.meter-image' | translate }}
          </label>
          <input
            pInputText
            id="old-meter-image"
            formControlName="meterDocumentName"
            type="text"
            [readOnly]="!oldMeterDataSection.isDataEditable" />
        </div>
        <p-fileUpload
          #meterImageUploader
          mode="basic"
          accept="image/*"
          [disabled]="!oldMeterDataSection.isDataEditable"
          class="file-upload-button ui-g-3"
          id="meter-data-upload"
          (onSelect)="onImageUpload($event, meterImageUploader)"
          chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"></p-fileUpload>
      </div>
      <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 field-rows file-name-section" *ngIf="fileName">
        <a href="javascript:void(0)" (click)="downloadDocument()">{{ fileName }}</a>
        <i class="pi pi-trash pointer-cursor" (click)="removeFile()" *ngIf="oldMeterDataSection.isDataEditable"></i>
      </div>
    </form>
  </app-review-section>
</div>
